import { createContext, useContext } from 'react';
import resources from '../../resources/HN.Core.Filter.NPM.JS.nb-NO.json';
export const defaultResources = resources;
const ResourcesContext = createContext(defaultResources);
export const useResourcesContext = () => useContext(ResourcesContext);
export const ResourcesContextProvider = ResourcesContext.Provider;
